// @ts-nocheck
import CryptoJS from "crypto-js"; // 进行加密
/**
 * localStorage
 */
export let localCache = {
    set (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get (key) {
        var val = localStorage.getItem(key);
        var dataobj = JSON.parse(val);
        return dataobj;
    },
    remove (key) {
        return localStorage.removeItem(key);
    },
};
/**
 *时间格式化，保留年月日(从后台返回的日期 2021-09-18 10：10：09)
 */
export function formateDate(timestamp){
    let a = new Date(timestamp).getTime();
    const date = new Date(a);
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + '  ';
    // const h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
    // const m = (date.getMinutes() <10 ? '0'+date.getMinutes() : date.getMinutes()) ;
    // const s = date.getSeconds(); // 秒
    // const dateString = Y + M + D + h + m;
    const dateString = Y + M + D;
    return dateString;
};
/**
 * 时间格式化，保留年月日(自己新建的日期)
 * 返回：Sat Oct 23 2021 00:00:00 GMT+0800 (中国标准时间)
 */
export function formateTime (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero (str) {
    return ('00' + str).substr(str.length)
};


/*export const formateTime = (format, date = new Date()) => {
    if (!format) return "";
    const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月(月份从0开始，要+1)
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
    };
    for (let k in opt) {
        let r = new RegExp("(" + k + ")").exec(format);
        if (r) {
            // 若输入的长度不为1，则前面补零
            format = format.replace(
                r[1],
                RegExp.$1.length == 1 ? opt[k] : opt[k].padStart(RegExp.$1.length, "0")
            );
        }
    }
    return format;
};*/



/**
 *加密处理
 */
export const encryption = (params) => {
    let { data, type, param, key } = params;
    const result = JSON.parse(JSON.stringify(data));
    if (type === "Base64") {
        param.forEach((ele) => {
            result[ele] = btoa(result[ele]);
        });
    } else {
        param.forEach((ele) => {
            var data = result[ele];
            key = CryptoJS.enc.Latin1.parse(key);
            var iv = key;
            // 加密
            var encrypted = CryptoJS.AES.encrypt(data, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.ZeroPadding,
            });
            result[ele] = encrypted.toString();
        });
    }
    return result;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js